<div class="forgot-form-success">
  <div class="forgot-form-success__header">
    <h2 class="forgot-form-success__title">
      {{ 'forgotPasswordPage.successMessage' | translate }} {{ email() }}
    </h2>
    <p class="forgot-form-success__description">
      {{ 'forgotPasswordPage.spamFolderMessage' | translate }}
    </p>
  </div>

  <button class="forgot-form-success__back-to-login-btn" (click)="returnToLogin()">
    {{ 'forgotPasswordPage.returnToLogin' | translate }}
  </button>
</div>
